import { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import SystemsStore from 'Stores/SystemsStore';
import { NavItemConfig } from '../Siderbar.constant';
import SearchDropDown from './SearchDropdown';
import { GetGroupsListRequest, GetGroupsListResponse } from 'Services/Api/Groups/Types';
import { GET_GROUPS_LIST } from 'Services/Api/Groups/Queries';
import { useApolloClient } from '@apollo/client';

type Props = {
    systemsStore: SystemsStore,
    isSuperAdmin: boolean,
    showFilter: boolean,
    onPropertyChange: (propertyId: number) => void;
}

const defaultOption = { key: "sidebar.tenantSelector.allPropertiesOption", label: "sidebar.tenantSelector.allPropertiesOption", id: `0`, path: `0` };
const defaultSelection = { label: defaultOption.label, value: 0 }
const PropertySelection = ({ systemsStore, isSuperAdmin, showFilter, onPropertyChange }: Props) => {
    const [loading, setLoading] = useState(false);
    const [selectedProperty, setSelectedProperty] = useState<{ label: string, value: number }>(defaultSelection);
    const [properties, setProperties] = useState<NavItemConfig[]>([]);
    const { selectedTenant } = systemsStore;
    const tenantId = selectedTenant.value;
    const client = useApolloClient();

    const handleItemClick = (item: NavItemConfig) => {
        setSelectedProperty({ label: item.label, value: Number(item.path) })
    }

    const loadGroups = useCallback(async (parentId: number | null) => {
        if (parentId) {
            setLoading(true);
            try {
                const result = await client.query<
                    GetGroupsListResponse,
                    GetGroupsListRequest
                >({
                    query: GET_GROUPS_LIST,
                    fetchPolicy: 'no-cache',
                    variables: { sort: 'name:asc', filters: { parentId: isSuperAdmin ? parentId : null } }
                });
                const groups = (result.data?.listGroups ?? []).filter((item) => item.isProperty).map(item => ({ key: item.name, label: item.name, id: String(item.id), path: String(item.id) }));
                setProperties([defaultOption, ...groups]);

                let selectedOption = defaultOption;
                if(groups.length === 0) selectedOption = { key: selectedTenant.label, label: selectedTenant.label, id: `${selectedTenant.value}`, path: `${selectedTenant.value}` };
                else if(groups.length === 1) selectedOption = groups[0];
                handleItemClick(selectedOption);
            } catch (ex) {
                setSelectedProperty({...defaultSelection});
            } finally {
                setLoading(false);
            }
        } else {
            setSelectedProperty({...defaultSelection});
            setProperties([defaultOption]);
        }
    }, [client, isSuperAdmin, selectedTenant]);

    useEffect(() => {
        onPropertyChange(selectedProperty.value);
    }, [selectedProperty])

    useEffect(() => {
        loadGroups(tenantId);
    }, [tenantId])


    return <div className='tenant_dropdown-container' style={{ display: showFilter ? "block" : "none" }}>
        <SearchDropDown {...{ items: properties, loading, handleItemClick, isTenantSelector: false, selectedItem: selectedProperty, disableDropDown: loading || properties.length <= 2 }} />
    </div>
}

export default observer(PropertySelection);